import { defaultAxios, IParams } from './base';

export interface IPutLoanExecute extends IParams {
  preRequestDtlNo?: string;
}

export const putLoanExecute = (params: IPutLoanExecute) => {
  return defaultAxios().put(`/loan/executeLoan`, params, { timeout: 30000 });
};
